module.exports = __webpack_public_path__ + "img/bwbj.fd1df2c0.jpg";